import * as hooks from './hooks';
import TtamCreativeIdentityNoInfoAlert from './identity/no-info.vue';
import TtamCreativeIdentityUnavailableAlert from './identity/unavailable.vue';
import TtamCreativeIos14Alert from './ios14/index.vue';
import TtamCreativeRejectAlert from './reject/index.vue';
import TtamCreativeSplittestAlert from './splittest/index.vue';
import TtamCreativeAppProfilePageTypeAlert from './app-profile-page-type/index.vue';
import TtamCreativeShopAlert from './shop/index.vue';
import TtamCreativeCopyAlert from './copy/index.vue';
import TtamCreativeAnchorAlert from './anchor/index.vue';
import TtamCreativeAllProductUnavailableAlert from './product/index.vue';
import TtamCreativeAuthShopAlert from './edit-auth/index.vue';
import TtamCreativeCreateAuthShopAlert from './create-auth/index.vue';

export default {
  TtamCreativeIdentityNoInfoAlert,
  TtamCreativeIdentityUnavailableAlert,
  TtamCreativeIos14Alert,
  TtamCreativeRejectAlert,
  TtamCreativeSplittestAlert,
  TtamCreativeAppProfilePageTypeAlert,
  TtamCreativeShopAlert,
  TtamCreativeCopyAlert,
  TtamCreativeAnchorAlert,
  TtamCreativeAllProductUnavailableAlert,
  TtamCreativeAuthShopAlert,
  TtamCreativeCreateAuthShopAlert,
  ...hooks,
};
